export const typography = {
    fontSize: 16,
    fontFamily: 'Hind',
    h1: {
        fontSize: '6rem',
        fontWeight: 300,
        letterSpacing: '-1.5px',
        textTransform: 'none',
    },
    h2: {
        fontSize: '3.75rem',
        fontWeight: 300,
        letterSpacing: '-0.5px',
        textTransform: 'none',
    },
    h3: {
        fontSize: '3rem',
        fontWeight: 400,
        letterSpacing: '0px',
        textTransform: 'none',
    },
    h4: {
        fontSize: '2.125rem',
        fontWeight: 400,
        letterSpacing: '0.25px',
        textTransform: 'none',
    },
    h5: {
        fontWeight: 500,
        fontSize: '1rem',
        lineHeight: '18px',
    },
    h6: {
        fontSize: '1rem',
        fontWeight: 600,
        letterSpacing: '0.15px',
        textTransform: 'none',
    },
    subtitle1: {
        // title of tabs
        fontSize: '1.14286rem',
        fontWeight: 500,
        letterSpacing: '0.15px',
        textTransform: 'capitalize',
    },
    subtitle2: {
        //title of table
        fontSize: '0.95rem',
        fontWeight: 600,
        letterSpacing: '0.1px',
        textTransform: 'capitalize',
    },
    body1: {
        //content on table
        fontSize: '1rem',
        fontWeight: 600,
        letterSpacing: '0.15px',
        textTransform: 'none',
        lineHeight: '18px',
    },
    body2: {
        fontSize: '0.875rem',
        fontWeight: 500,
        letterSpacing: '0.15px',
        lineHeight: '18px',
        textTransform: 'none',
    },
    button: {
        fontSize: '1rem',
        fontWeight: 600,
        letterSpacing: '0.4px',
        textTransform: 'capitalize',
    },
    caption: {
        fontSize: '0.75rem',
        fontWeight: 400,
        letterSpacing: '0.4px',
        textTransform: 'none',
    },
    overline: {
        fontSize: '0.75rem',
        fontWeight: 400,
        letterSpacing: '1px',
        textTransform: 'capitalize',
    },
};